import React from 'react';
import { useTranslation, Trans } from 'react-i18next';

export default function UnauthorizedMessage() {
  const { t } = useTranslation();

  return (
    <div className="empty empty_right">
      <strong>{t('error_unauthorized_title')}</strong>
      <p>
        <Trans i18nKey="error_unauthorized_description" />
      </p>
    </div>
  );
}
